import { useState } from "react";

import { toast } from "react-toastify";

import { useFormik } from "formik";

import { Link } from "react-router-dom";
import {
  FiArrowLeft,
  FiCheck,
  FiLock,
  FiPhone,
  FiUser,
} from "react-icons/fi";
import styles from "./CreateAccount.module.css";
import api from "../../services/axiosConfig";
import { OTP_SEND } from "../../constant-value";
import { validationRegisterSchema } from "../../constant-value/schema";



const CreateAccount = ({ nextStep, onSendData }) => {

  const [alreadyRegistered, setAlreadyRegistered] = useState(false);

  const [body, setBody] = useState({
    name: "",
    mobileNumber: "",
    password: "",
    confirmPassword: "",
  });

  const [otp, setOtp] = useState({
    phoneNumber: "",
  });

  const handleSendData = () => {
    // ارسال داده به والد از طریق تابع callback
    onSendData(body);
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleSubmit,
  } = useFormik({
    enableReinitialize: true,
    initialValues: body,
    validationSchema: validationRegisterSchema,

    onSubmit: (values) => {
      api
        .post(`/${OTP_SEND}`, otp)
        .then((res) => {

          if (res.data.isSuccess) {
            message(res.data.message, "success");
            handleSendData();
            nextStep();
          } else {
            message(res.data.message, "warn");
          }
        })
        .catch((error) => {

          if (error.response?.status === 200 && error.message==="این کاربری قبلا ثبت نام نموده است") {

            setAlreadyRegistered(true);
            
            return;

          }

          message(
            "جند دقیقه دیگر تلاش نمایید، خطایی رخ داده است",
            "warn"
          );
        });
    },
  });

  const changeHandle = (evt) => {
    const { id, value } = evt.target;

    setBody({
      ...body,
      [id]: value,
    });

    if (id === "mobileNumber") {
      setOtp((prevOtp) => ({
        ...prevOtp,
        phoneNumber: value,
      }));
    }
  };

  const message = (message, type) => {
    if (type === "warn") {
      toast.warning(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.success(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const getFieldClass = (field) => {
    return errors[field] && touched[field]
      ? `${styles.inputWrapper} ${styles.inputError}`
      : styles.inputWrapper;
  };

  return (
    <main className={styles.page} dir="rtl">
      <div className={styles.backgroundGlow} />

      <section className={styles.registerWrapper}>
        <div className={styles.registerCard}>
          {/* Header */}
          <div className={styles.header}>
            <div className={styles.logo}>
              <span className={styles.logoInner}>
                <img src="/logo.png" alt="logo" />
              </span>
            </div>

            <h1>ایجاد حساب کاربری</h1>

            <p>
              اطلاعات خود را وارد کنید تا حساب کاربری شما
              ایجاد شود
            </p>
          </div>

          {/* Form */}
          <form
            onSubmit={handleSubmit}
            className={styles.form}
          >
            {/* Name */}
            <div className={styles.field}>
              <label htmlFor="name">
                نام کامل
              </label>

              <div className={getFieldClass("name")}>
                <FiUser className={styles.inputIcon} />

                <input
                  id="name"
                  type="text"
                  value={values.name}
                  onChange={changeHandle}
                  onBlur={handleBlur}
                  placeholder="نام و نام خانوادگی"
                  autoComplete="name"
                  disabled={isSubmitting}
                />
              </div>

              {errors.name && touched.name && (
                <div className={styles.fieldError}>
                  {errors.name}
                </div>
              )}
            </div>

            {/* Mobile */}
            <div className={styles.field}>
              <label htmlFor="mobileNumber">
                شماره همراه
              </label>

              <div
                className={getFieldClass(
                  "mobileNumber"
                )}
              >
                <FiPhone
                  className={styles.inputIcon}
                />

                <input
                  id="mobileNumber"
                  type="tel"
                  value={values.mobileNumber}
                  onChange={changeHandle}
                  onBlur={handleBlur}
                  placeholder="09xxxxxxxxx"
                  autoComplete="tel"
                  inputMode="tel"
                  disabled={isSubmitting}
                />
              </div>

              {errors.mobileNumber &&
                touched.mobileNumber && (
                  <div className={styles.fieldError}>
                    {errors.mobileNumber}
                  </div>
                )}
            </div>

            {/* Password */}
            <div className={styles.field}>
              <label htmlFor="password">
                رمز عبور
              </label>

              <div
                className={getFieldClass("password")}
              >
                <FiLock
                  className={styles.inputIcon}
                />

                <input
                  id="password"
                  type="password"
                  value={values.password}
                  onChange={changeHandle}
                  onBlur={handleBlur}
                  placeholder="حداقل 6 کاراکتر"
                  autoComplete="new-password"
                  disabled={isSubmitting}
                />
              </div>

              {errors.password &&
                touched.password && (
                  <div className={styles.fieldError}>
                    {errors.password}
                  </div>
                )}
            </div>

            {/* Confirm Password */}
            <div className={styles.field}>
              <label htmlFor="confirmPassword">
                تکرار رمز عبور
              </label>

              <div
                className={getFieldClass(
                  "confirmPassword"
                )}
              >
                <FiLock
                  className={styles.inputIcon}
                />

                <input
                  id="confirmPassword"
                  type="password"
                  value={values.confirmPassword}
                  onChange={changeHandle}
                  onBlur={handleBlur}
                  placeholder="رمز عبور را دوباره وارد کنید"
                  autoComplete="new-password"
                  disabled={isSubmitting}
                />
              </div>

              {errors.confirmPassword &&
                touched.confirmPassword && (
                  <div className={styles.fieldError}>
                    {errors.confirmPassword}
                  </div>
                )}
            </div>

            {/* Privacy */}
            <div className={styles.privacy}>
              <span className={styles.checkIcon}>
                <FiCheck />
              </span>

              <span>
                با ثبت نام،{" "}
                <Link to="/privacy">
                  حریم خصوصی
                </Link>{" "}
                را می‌پذیرم
              </span>
            </div>

            {/* Submit */}
            <button
              type="submit"
              className={styles.submitButton}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className={styles.spinner} />
                  <span>در حال ثبت نام...</span>
                </>
              ) : (
                <>
                  <span>ادامه و دریافت کد</span>
                  <FiArrowLeft />
                </>
              )}
            </button>

            {alreadyRegistered && (
                <div className={styles.alreadyRegistered}>
                    <div>
                    این شماره همراه قبلاً ثبت‌نام کرده است.
                    </div>

                    <div className={styles.loginHint}>
                    لطفاً وارد حساب کاربری خود شوید.
                    </div>

                    <Link to="/login" className={styles.loginButton}>
                    ورود به حساب
                    </Link>
                </div>
            )}

          </form>

          {/* Login */}
          <div className={styles.loginLink}>
            <span>قبلاً ثبت نام کرده‌اید؟</span>

            <Link to="/login">
              وارد حساب شوید
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CreateAccount;
